import React from "react";
import { CircularProgress } from "@mui/material";
import styles from "./MembersListLoader.module.css";

export default function MembersListLoader() {
	return (
		<div className={styles["members-list__empty-state"]}>
			<CircularProgress />
		</div>
	);
}
